import lodash from 'lodash';
import React from 'react';
import withDraggable from '~app/core/withDraggable';
import { ReactComponent as InfinityIcon } from '~app/resources/images/infinity.svg';

// flow to and flow from links
function InfinityNode({ selected, type }) {
  return (
    <div
      className={`canvas__infinity_node handle ${selected ? 'selected' : ''}`}
      tabIndex={0}
      aria-dropeffect={selected ? 'move' : 'none'}
      aria-grabbed={selected}
      aria-current={selected}
      role="button"
      aria-label={`draggable ${type} ${selected ? 'current' : ''}`}
    >
      <InfinityIcon />
    </div>
  );
}

export default React.memo(
  withDraggable(InfinityNode, {
    draggableProps: { handle: '.handle', defaultClassName: 'canvas-draggable' },
  }),
  lodash.isEqual,
);
